const initialState = { ids: [], entities: {} };
export default function reducer(state = initialState /* , action */) {
  return state;
}

export const selectors = {
  getAllFields(state) {
    return state.fields.ids.map(id => state.fields.entities[id]);
  },

  getFieldEntities(state) {
    return state.fields.entities;
  },

  getFieldsWithRoles(state) {
    const roles = state.roles.ids
      .map(r => state.roles.entities[r])
      .sort((a, b) => a.title.localeCompare(b.title));

    return state.fields.ids.map(fieldId => ({
      ...state.fields.entities[fieldId],
      roles: roles.filter(role => role.fieldId === fieldId)
        .map(({ id, slug, title }) => ({ id, slug, title }))
    }));
  }
};
